// extracted by mini-css-extract-plugin
module.exports = {"container":"MetricsSummary-module__container__3uKR5","right":"MetricsSummary-module__right__25XNU","left":"MetricsSummary-module__left__E30_1"};